export default __webpack_public_path__ + "static/media/ovary_main.13bd61b7.jpg";